"use client";

export { ModalShell } from "@aera/ui";
export type { ModalShellProps } from "@aera/ui";
